<template>
  <div>
    <div class="bsod container">
      <div :class="{ disappearTitle: disappearTitle }" v-if="!worldPassed">
        <h1 class="neg title"><span class="bg">KIZI404 - NOT FOUND</span></h1>
        <div
          class="passworld"
          :class="{
            typewriter: typewriter,
            deleteTypewriter: deleteTypewriter,
          }"
          v-show="typeShow"
        >
          <div>
            <p v-html="question"></p>
            <br />
          </div>
          <div class="form nav" :class="{ formActive: formActive }">
            <div v-on:submit.prevent="checkPassword">
              <input
                type="password"
                name="kizi-password"
                style="text-align:center;"
                v-model="inputValue"
                @keypress.enter="checkPassword"
                id="passworld-input"
              />
            </div>
            <div>
              <a @click="checkPassword()" class="link"
                >PRESS F TO PAY RESPECTS</a
              >
            </div>
          </div>
        </div>
      </div>
      <div v-if="worldPassed" class="infoMobile">
        <div v-if="isMobile">
          <div class="portrait">
            <h2>**Disclaimer**</h2>
            <p class="text-kizi-center">
              * Since our orbital emissions are transmitted from a DIY ship,
              they’re best experienced from a desktop computer, all the better
              if it runs on Windows 95. Being DIY af means bugs can occur
              unexpectedly, so if you mess around with your browser window or
              stuff like that, it will probably look like s***.
            </p>
            <p>
              * Since you are using a technology which doesn't exist anymore in
              our time, from here on out it will be required from you to
              navigate your mobile device landscape style (instead of portrait).
            </p>
            <p>
              * While wandering in outer space, we’re trying our best, with the
              time, knowledge, and few resources we have to avoid using
              technology we can't control or fully understand. We don’t nor will
              we ever ask and, thus, use any of your data (why would we).
            </p>
            <p>
              * If you have any question or advice on how to make the ship more
              secure please contact kizi404@protonmail.com
            </p>
            <p class="any-key">
              Turn your screen to continue..<span class="blink">_</span>
            </p>
          </div>
          <div class="landscape nav">
            <img src="@/assets/medias/images/parabol.png" height="150" />
            <p>
              Sweet, let's move on... (soundOn)
            </p>
            <a @click="hyperspaceJump" class="link">{{ hyperspaceText }}</a>
          </div>
        </div>
        <div v-else class="scrollable no-scrollbar">
          <h2>**Disclaimer**</h2>
          <p class="text-kizi-center">
            * Since our orbital emissions are transmitted from a DIY ship,
            they’re best experienced from a desktop computer, all the better if
            it runs on Windows 95. Being DIY af means bugs can occur
            unexpectedly, so if you mess around with your browser window or
            stuff like that, it will probably look like s***.
          </p>
          <p>
            * While wandering in outer space, we’re trying our best, with the
            time, knowledge, and few resources we have to avoid using technology
            we can't control or fully understand. We don’t nor will we ever ask
            and, thus, use any of your data (why would we).
          </p>
          <p>
            * If you have any question or advice on how to make the ship more
            secure please contact kizi404@protonmail.com
          </p>
          <div class="nav">
            <img src="@/assets/medias/images/parabol.png" height="150" />
            <p>
              Sweet, let's move on... (soundOn)
            </p>
            <a @click="hyperspaceJump" class="link">{{ hyperspaceText }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { delay } from "@/variables.js";
import passworld_responses from "@/components/utilities/passworld_responses.js";
import MainMixinVue from "./utilities/MainMixin.vue";
export default {
  name: "Passworld",
  title: "Passworld",
  data() {
    return {
      formActive: false,
      question: "enter the passworld:",
      inputValue: "",
      typewriter: false,
      typeShow: false,
      deleteTypewriter: false,
      password: "PRELUDE",
      password_press: "VIVELAPRESSE",
      disappearTitle: false,
      halResponses: passworld_responses,
      tries: 0,
      worldPassed: false,
      hyperspaceText: "I'M READY",
      randomTries: Math.floor(Math.random() * 10 + 5),
    };
  },
  mixins: [MainMixinVue],
  methods: {
    checkPassword() {
      if (
        this.inputValue.toUpperCase() == this.password ||
        this.inputValue.toUpperCase() == this.password_press
      ) {
        this.formActive = false;
        delay(500).then(() => {
          this.typewriter = false;
          this.deleteTypewriter = true;
          delay(800).then(() => {
            this.disappearTitle = true;
            delay(1000).then(() => {
              if (this.inputValue.toUpperCase() == this.password_press) {
                this.$cookies.set("is_fellow", true, 60 * 60);
                this.$router.push("/presskit-one");
              } else {
                delay(500).then(() => {
                  this.worldPassed = true;
                  this.$cookies.set("is_fellow", true, 72 * 60 * 60);
                });
              }
            });
          });
        });
      } else {
        this.typewriter = false;
        this.deleteTypewriter = true;
        delay(100).then(() => {
          this.question = this.halResponses[
            Math.floor(Math.random() * this.halResponses.length)
          ].text;
          this.deleteTypewriter = false;
          this.typewriter = true;
          this.tries++;

          if (this.tries > this.randomTries) {
            this.$router.push("/tuto-respect");
          }
        });
      }
    },
    hyperspaceJump() {
      this.$store.commit("getInSpaceship");
      this.hyperspaceText = "LINKING...";
      delay(1000).then(() => {
        this.$router.push("/spaceship");
      });
    },
  },
  mounted() {
    this.typeShow = true;
    this.typewriter = true;
    delay(1500).then(() => {
      this.formActive = true;
      document.getElementById("passworld-input").focus();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/landing-error.scss";

$char-w: 1ch;
$gap: 0.5 * $char-w;
$n-char: 7;
$in-w: $n-char * ($char-w + $gap);

input {
  border: none;
  padding: 0;
  width: $in-w;
  background: repeating-linear-gradient(
      90deg,
      $light-grey 0,
      $light-grey $char-w,
      transparent 0,
      transparent $char-w + $gap
    )
    0 100% / #{$in-w - $gap} 2px no-repeat;
  font: $font-stack 2rem;
  letter-spacing: $gap;
  color: $light-grey;
  font-size: 3rem;
  &:focus {
    outline: none;
    color: $light-grey;
  }
  margin-bottom: 25px;
}

.formActive {
  opacity: 1;
  transition: 1s;
}

.disappearTitle {
  opacity: 0;
  transition: 2s;
}

.infoMobile {
  h2 {
    text-align: center;
    font-weight: initial;
  }

  margin-top: -15vh;
  margin-bottom: 5vh;
}

@media screen and (max-width: 800px) {
  .infoMobile {
    margin-top: -5vh;
  }
}
</style>
